import type React from 'react'

type Props = {
  className?: string
  size?: number
}

const IconInfo: React.FC<Props> = ({ className, size = 20 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.375C12.1309 1.375 15.5 4.74414 15.5 8.875C15.5 13.0352 12.1309 16.375 8 16.375C3.83984 16.375 0.5 13.0352 0.5 8.875C0.5 4.74414 3.83984 1.375 8 1.375ZM8 14.9688C11.3398 14.9688 14.0938 12.2441 14.0938 8.875C14.0938 5.53516 11.3398 2.78125 8 2.78125C4.63086 2.78125 1.90625 5.53516 1.90625 8.875C1.90625 12.2441 4.63086 14.9688 8 14.9688ZM9.17188 11.2188C9.55273 11.2188 9.875 11.541 9.875 11.9219C9.875 12.332 9.55273 12.625 9.17188 12.625H6.82812C6.41797 12.625 6.125 12.332 6.125 11.9219C6.125 11.541 6.41797 11.2188 6.82812 11.2188H7.29688V9.34375H7.0625C6.65234 9.34375 6.35938 9.05078 6.35938 8.64062C6.35938 8.25977 6.65234 7.9375 7.0625 7.9375H8C8.38086 7.9375 8.70312 8.25977 8.70312 8.64062V11.2188H9.17188ZM8 7C7.47266 7 7.0625 6.58984 7.0625 6.0625C7.0625 5.56445 7.47266 5.125 8 5.125C8.49805 5.125 8.9375 5.56445 8.9375 6.0625C8.9375 6.58984 8.49805 7 8 7Z"
        fill="#768BA7"
      />
    </svg>
  )
}

export default IconInfo
